import React, { Component } from 'react';

import './Page.css';

class Page extends Component {
  render() {
    let {
      title,
    } = this.props;

    return (
      <div className="Page-empty-container">
        <div className="Page-empty-header">
          <div className="Page-empty-title">{title}</div>
        </div>
        <div className="Page-empty-body">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Page;


// WEBPACK FOOTER //
// ./src/pages/Page/Empty.js